// NG 2
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

// APP
import { AppConfig } from '../app.config';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';

@Injectable()
export class BuildingService extends BaseService  {

    _baseUrl: string = AppConfig.config.defaultServicePath + 'MIHBuilding/'; 
    
  

    constructor(private http: Http
        , private progressService: ProgressService) {
        super();
    }

    saveBuilding(building) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveBuilding', building, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    // saveSiteBuilding(building) {
    //     this.progressService.add();
    //     return this.http.post(this._baseUrl + 'saveSite', building, this.addHeader())
    //         .map((resp: Response) => resp.json())
    //         .catch(this.errorHandler)
    //         .finally(() => this.progressService.remove())
    // }

    getBuildingsByProjectId(projectId) {
        this.progressService.add();
        
        return this.http.get(this._baseUrl + 'GetBuildings?projectId=' + projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getBuildingByProjBldgId(projectBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetBuildingByProjectBuildingId?projectBuildingId=' + projectBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetBuildingByProjectBuildingIdAndType(projectBuildingId, questionType) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetBuildingByProjectBuildingId?projectBuildingId=' + projectBuildingId + '&ProjBuildingTrackingType=' + questionType, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }




    deleteBuilding(projectId, buildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'DeleteBuilding?projectId=' + projectId + '&buildingId=' + buildingId, this.addHeader())       
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getBuildingsByBBL(boro, block, lot) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetBuildingsByBBL?boro=' + boro + '&block=' + block + '&lot=' + lot, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetSitesToAddToProjectBuilding(projectId, projectBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetSitesToAddToProjectBuilding?projectId=' + projectId + '&projectBuildingId=' + projectBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetAllDevSiteAssociationsforProj(projectId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetAllDevSiteAssociationsforProj?projectId=' + projectId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }


    GetSitesToAddToDevProjectBuilding(projectId, devProjectBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetSitesToAddToDevProjectBuilding?projectId=' + projectId + '&devProjectBuildingId=' + devProjectBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    
    AssocaiateDevAndSite(devSiteAssociations) {
 
        this.progressService.add();
        return this.http.post(this._baseUrl + 'AssocaiateDevAndSite', devSiteAssociations, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    DeleteDevSiteAssociation(devSiteAssociationId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'DeleteDevSiteAssociation?devSiteAssociationId=' + devSiteAssociationId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetBuildingInfoOnlyByProjectBuildingId(projectBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetBuildingInfoOnlyByProjectBuildingId?projectBuildingId=' + projectBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

}
